import UserService from '../../service/user'
import DomainCommon from "../../service/common";

const Action = {
    GET_USER: "GET_USER",
    GET_USERS: "GET_USERS",
    GET_USER_ERROR: "GET_USER_ERROR",
};

const ActionCreator = {

    getUser(userId) {
        return async (dispatch) => {
            try {
                const user = await UserService.findById(userId)
                dispatch({type: Action.GET_USER, user})
                return user
            } catch (error) {
                // 將 error 丟給 httpResponseErrorHandler 處理 , 之後將結果向外拋出
                throw dispatch({type: Action.GET_USER_ERROR, error})
            }
        };
    },

    getUsers() {
        return async (dispatch) => {
            try {
                const users = await UserService.list()
                dispatch({type: Action.GET_USERS, users})
                return users
            } catch (error) {
                throw dispatch({error})
            }
        };
    },

    avatarGetUrl({base64Image}) {
        return async (dispatch) => {
            try {
                return await UserService.avatarGetUrl({base64Image})
            } catch (error) {
                throw dispatch({error})
            }
        }
    },

    sendCustomMail({ userId, subject, content }) {
        return async (dispatch) => {
            try {
                await UserService.sendCustomMail({ userId, subject, content })
                return dispatch(ActionCreator.getUser(userId))
            } catch (error) {
                throw dispatch({error})
            }
        };
    },

};


const initialState = {
    users: [],
    user: {},
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_USER:
            return {
                ...state,
                user: action.user
            };
        case Action.GET_USERS:
            return {
                ...state,
                users: action.users
            };
        default: {
            return state
        }
    }
};

export default {Action, ActionCreator, Reducer}



// WEBPACK FOOTER //
// ./src/store/actionreducers/user.js